'use strict';

module.exports = tableCell;

function tableCell(node) {
  return this.all(node).join('');
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/table-cell.js
// module id = 310
// module chunks = 96961042003272 139266963665775